import { useNavigate } from 'react-router-dom';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { XCircle } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const PaymentCancel = () => {
  const navigate = useNavigate();
  const { language, localize } = useLanguage();

  return (
    <div className="min-h-screen gradient-hero flex items-center justify-center p-6">
      <Card className="border-0 shadow-emerald-hover max-w-md w-full">
        <CardContent className="p-8 text-center">
          <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-red-100 flex items-center justify-center">
            <XCircle className="w-10 h-10 text-red-600" />
          </div>
          <h1 className="text-2xl font-bold text-slate-900 mb-2">
            {localize({ ar: 'تم إلغاء الدفع', en: 'Payment Cancelled' })}
          </h1>
          <p className="text-slate-500 mb-6">
            {localize({ ar: 'تم إلغاء عملية الدفع. يمكنك المحاولة مرة أخرى في أي وقت.', en: 'Payment has been cancelled. You can try again anytime.' })}
          </p>
          <div className="space-y-3">
            <Button 
              onClick={() => navigate('/student/bookings')}
              className="w-full bg-emerald-500 hover:bg-emerald-600 text-white rounded-full"
              data-testid="view-bookings-btn"
            >
              {localize({ ar: 'عرض الحجوزات', en: 'View Bookings' })}
            </Button>
            <Button 
              onClick={() => navigate('/student/search')}
              variant="outline"
              className="w-full rounded-full"
              data-testid="search-teacher-btn"
            >
              {localize({ ar: 'البحث عن أستاذ', en: 'Search for a Teacher' })}
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default PaymentCancel;
